import { Reducer } from 'redux';
import { SummaryState } from './types';
import { StudentActionTypes } from '../types';
import { Status, VisaStatus, CoreActionTypes } from '../core/types';
import { DocActionTypes } from '../documents/types';
import { DocActionTypes as FinDocActionTypes } from '../financeDocuments/types';
import { DocActionTypes as FollowUpDocActionTypes } from '../followUpDocuments/types';

const initialState: SummaryState = {
  p_key: '',
  s_key: '',
  docType: 'summary',
  lastUpdatedAt: '',
  totalPagesRequired: 0,
  totalPagesCompleted: 0,
  beforeTravelDocsComplete: 0,
  afterArrivalDocsComplete: 0,
  lastUpdatedBy: '',
  lastUpdatedRole: '',
  lastUpdatedAction: '',
  intakeId: '',
  offerId: '',
  country: '',
  courseFee: 0,
  courseName: '',
  dob: '',
  email: '',
  givenName: '',
  surname: '',
  nationality: '',
  age: 0,
  countryOfVisaApplication: '',
  startDate: '',
  uni: '',
  isAgent: '',
  agentName: '',
  depositPaid: false,
  cas_status: Status.PRE_DEPOSIT,
  calendlyInterviews: [],
  recordedInterviews: [],
  casStatusUpdatedAt: 0,
  studentDetailsComplete: 0,
  historyComplete: 0,
  financeComplete: 0,
  consentsComplete: 0,
  studentDetailsRequired: 0,
  historyRequired: 0,
  financeRequired: 0,
  consentsRequired: 0,
  agentDetailsRequired: 0,
  agentDetailsComplete: 0,
  totalRequired: 0,
  totalCompleted: 0,
  totalPercentageComplete: '',
  docsUploaded: 0,
  docsTotal: 0,
  agentDocsUploaded: 0,
  agentDocsTotal: 0,
  finDocsUploaded: 0,
  finDocsTotal: 0,
  followUpDocsUploaded: 0,
  followUpDocsTotal: 0,
  newDocsUploaded: false,
  newFinDocsUploaded: false,
  isStudentDetailsComplete: false,
  isHistoryComplete: false,
  isConsentsComplete: false,
  isFinanceComplete: false,
  isDocsComplete: false,
  isFinDocsComplete: false,
  isPreCASComplete: false,
  isDepositComplete: false,
  isFinanceSponsorsValid: false,
  isTasksComplete: false,
  tasksCompleteAt: 0,

  isNewDocuments: false,
  isNewMessage: false,
  lastTouch: 0,
  fundsMatured: [{ type: 'INFO', value: 'N/A' }],
  visaStatus: VisaStatus.NONE,
  updated_at: 0,
  unreadMessagesStudent: 0,
  unreadMessagesUni: 0,
  unreadMessagesUniToAgent: 0,
  unreadMessagesStudentToAgent: 0,
  unreadMessagesAgentToUni: 0,
  unreadMessagesUniSecure: 0,
  newMessage: false,
  unreadMessagesStudentSecure: 0,
  agentAccess: '',
  regionConfigId: '',
  withAgent: false,
  dependants: {},
  beforeTravelDocsRequired: 0,
  afterArrivalDocsRequired: 0,
  agentFinDocsUploaded: 0,
  agentFinDocsTotal: 0,
  assignedAgents: [],
  livedInUKLast12Months: false,
  whatsApp: '',
  lastTouchByStudentOrAgent: 0,
  // Legacy properties for backwards compatibility
  beforeTravelDocsComplet: 0,
  beforeTravelAgentDocsComplet: 0,
  beforeTravelAgentDocsRequired: 0,
  isBeforeTravelDocsSectionStarted: 0,
  isBeforeTravelDocsSectionComplet: 0,
  afterArrivalDocsComplet: 0,
  afterArrivalAgentDocsComplet: 0,
  afterArrivalAgentDocsRequired: 0,
  isAfterArrivalDocsSectionStarted: 0,
  isAfterArrivalDocsSectionComplet: 0,
};

const reducer: Reducer<SummaryState> = (state = initialState, action) => {
  switch (action.type) {
    case StudentActionTypes.GET_STUDENT_RECORD_SUCCESS: {
      return {
        ...initialState,
        ...action.payload.student.summary,
      };
    }
    case CoreActionTypes.UPDATE_VISA_STATUS: {
      return {
        ...state,
        visaStatus: action.payload,
      };
    }
    case StudentActionTypes.UPDATE_SUMMARY: {
      if (action.payload?.summary) {
        return {
          ...state,
          ...action.payload.summary,
        };
      }
      return state;
    }

    case StudentActionTypes.UPDATE_CONFLICT_SUCCESS: {
      if (action.payload.summary) {
        return { ...initialState, ...action.payload.summary };
      }
      return state;
    }
    case StudentActionTypes.SAVE_DOCUMENTS_SUCCESS:
    case DocActionTypes.TOGGLE_DOC_SUCCESS:
    case StudentActionTypes.DELETE_DOCUMENT_FILE_SUCCESS: {
      const { complete, required } = action.payload;
      return {
        ...state,
        docsComplete: complete,
        docsRequired: required,
      };
    }
    case StudentActionTypes.SAVE_FINANCE_DOCUMENTS_SUCCESS:
    case FinDocActionTypes.TOGGLE_DOC_SUCCESS:
    case StudentActionTypes.DELETE_FINANCE_FILE_SUCCESS: {
      const { complete, required } = action.payload;
      return {
        ...state,
        finDocsComplete: complete,
        finDocsRequired: required,
      };
    }
    case StudentActionTypes.SAVE_FOLLOW_UP_DOCUMENTS_SUCCESS:
    case FollowUpDocActionTypes.TOGGLE_DOC_SUCCESS: {
      const { beforeComplete, beforeRequired, afterComplete, afterRequired } = action.payload;
      return {
        ...state,
        beforeTravelDocsComplete: beforeComplete,
        beforeTravelDocsRequired: beforeRequired,
        afterArrivalDocsComplete: afterComplete,
        afterArrivalDocsRequired: afterRequired,
      };
    }
    default: {
      return state;
    }
  }
};

export { reducer as SummaryReducer };
